import { Outlet } from "react-router-dom";

import useScrollDirection from "../lib/hooks/useScrollDirection";
import { useUser } from "../lib/hooks/useUser";

import { LoadingOverlay } from "./LoadingOverlay";
import { UIAppState } from "./UIAppState/UIAppState";

export const LearnLayout: React.FC = () => {
  const user = useUser();
  const scrollDirection = useScrollDirection();
  if (user.user == null) return <LoadingOverlay />;

  return (
    <>
      <div data-scroll-direction={scrollDirection}>
        <Outlet />
      </div>
      <UIAppState />
    </>
  );
};
